import PropTypes from 'prop-types';
import { Component } from 'react';
import { userInfoSync } from 'hub-http/userInfo';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ImageUploadWithIframePicker from 'FileManagerLib/picker/ImageUploadWithIframePicker';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import { HEADER_BACKGROUND_IMAGE_STYLE } from 'knowledge-content-ui/constants/TemplateEditorConstants';
import FileManager from '../../components/FileManager';
import ReadOnlyImageUpload from './ReadOnlyImageUpload';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BASE_I18N_KEY = 'knowledgeContentUI.templateEditor.fields.backgroundImage';
const STYLE_LABEL_KEYS = {
  STRETCH: `${BASE_I18N_KEY}.style.stretch`,
  TILE: `${BASE_I18N_KEY}.style.tile`
};
class BackgroundImageField extends Component {
  constructor(...args) {
    super(...args);
    this.handleFileUploadChange = src => {
      if (src !== this.props.imageSrc) {
        this.props.onFieldChange({
          imageSrc: src,
          imageStyle: this.props.imageStyle
        });
      }
    };
    this.handleRemove = () => {
      this.props.onFieldChange({
        imageSrc: null,
        imageStyle: this.props.imageStyle
      });
    };
    this.handleStyleChange = style => {
      this.props.onFieldChange({
        imageSrc: this.props.imageSrc,
        imageStyle: style
      });
    };
  }
  renderLabel() {
    const {
      imageStyle,
      label
    } = this.props;
    const removeButton = /*#__PURE__*/_jsx(UIButton, {
      use: "transparent",
      onClick: this.handleRemove,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${BASE_I18N_KEY}.remove`
      })
    });
    return /*#__PURE__*/_jsxs(UIFlex, {
      justify: "between",
      children: [/*#__PURE__*/_jsx("div", {
        children: label
      }), imageStyle ? /*#__PURE__*/_jsx("div", {
        children: removeButton
      }) : null]
    });
  }
  renderImageStyleOptions() {
    const {
      imageSrc,
      imageStyle
    } = this.props;
    if (!imageSrc) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      children: Object.keys(HEADER_BACKGROUND_IMAGE_STYLE).map(style => /*#__PURE__*/_jsx(UIRadioInput, {
        inline: true,
        value: style,
        checked: style === imageStyle,
        onChange: () => this.handleStyleChange(style),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: STYLE_LABEL_KEYS[style]
        })
      }, style))
    });
  }
  renderImageUpload() {
    const {
      imageSrc,
      readOnly
    } = this.props;
    if (readOnly) {
      return /*#__PURE__*/_jsx(ReadOnlyImageUpload, {
        imageUrl: imageSrc
      });
    }
    return /*#__PURE__*/_jsx(FileManager, {
      auth: userInfoSync(),
      children: /*#__PURE__*/_jsx(ImageUploadWithIframePicker, {
        imageUrl: imageSrc,
        onChange: this.handleFileUploadChange,
        pickerType: "SIDE_MODAL"
      })
    });
  }
  render() {
    const {
      description
    } = this.props;
    return /*#__PURE__*/_jsx(UIFormControl, {
      help: description,
      label: this.renderLabel(),
      children: /*#__PURE__*/_jsxs("div", {
        children: [this.renderImageUpload(), this.renderImageStyleOptions()]
      })
    });
  }
}
BackgroundImageField.propTypes = {
  imageSrc: PropTypes.string,
  imageStyle: PropTypes.string,
  description: PropTypes.string,
  label: PropTypes.object.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired
};
export default BackgroundImageField;